<template>
    <div class="lo article">
        <slot></slot>
    </div>
</template>

<script>
    export default {
        data: function(){
            
            return {}
        },
    }
</script>

<style scoped lang="scss">

    .lo.article::v-deep {
        @extend %grid-l;
        flex: 1;
        position: relative;

        .g.row {

            > .g.cell {

                @include media('mobile') { //RWD 100%
                    float: none !important;
                    width: auto !important;
                }
            }
        }

        + .lo-additional {
            margin-top: $interval-l;
        }
    }
</style>
